import { render } from "./Form.vue?vue&type=template&id=7fc5550f&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=7fc5550f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7fc5550f"

export default script